import { useInfiniteQuery } from 'react-query'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import { useAuth } from '@dc-shared-web/providers/AuthProvider'

import {
  getTeamSelectOptions,
  GetTeamsSelectOptionsResponse,
} from '@dc-shared-web/hooks/api/team/getTeamSelectOptions'

export const useGetTeamSelectOptions = ({ filter }: { filter: string }) => {
  const { user } = useAuth()
  const apiClient = useAxiosContext()

  return useInfiniteQuery<GetTeamsSelectOptionsResponse, Error>({
    queryKey: ['TeamSelectOptions', filter],
    queryFn: ({ pageParam = 0 }) =>
      getTeamSelectOptions(apiClient, user, {
        p: pageParam + 1,
        pp: 20,
        q: filter.toLowerCase() || undefined,
      }),
    getNextPageParam: (lastPage, pages) =>
      lastPage.hasMore ? pages.length : undefined,
    enabled: !!user.id,
  })
}
